// useUnreadCount hook - Poll unread notification count
// Feature: 015-we-want-to
// T025: Frontend hook for unread count with polling

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import { useAuthStore } from '../store/authStore';

interface UnreadCountResponse {
  unread_count: number;
}

interface UseUnreadCountOptions {
  enablePolling?: boolean;
}

export function useUnreadCount(options: UseUnreadCountOptions = {}) {
  const { enablePolling = true } = options;
  const { isAuthenticated } = useAuthStore();

  const query = useQuery<UnreadCountResponse>({
    queryKey: ['notifications', 'unread-count'],
    queryFn: async () => {
      return apiClient.get<UnreadCountResponse>('/notifications/unread-count');
    },
    staleTime: 30000, // 30 seconds
    refetchInterval: enablePolling ? 30000 : false, // Poll every 30 seconds if enabled
    refetchOnWindowFocus: true,
    // Only fetch if authenticated
    enabled: isAuthenticated,
  });

  return {
    ...query,
    unreadCount: query.data?.unread_count ?? 0,
  };
}
